import {createUseStyles} from 'react-jss'

export default createUseStyles({
  label: {
    display: 'flex',
    flexDirection: "column",
    color: 'rgba(0,0,0,0.8)',
    marginBottom: 10,
    '& span': {
      fontSize: 14,
      marginBottom: 5
    }
  },
  input: {
    border: 'none',
    border: '2px solid rgba(0,0,0,0.6)',
    borderRadius: 5,
    height: 40,
    padding: '0 5px',
    outline: 'none',
    transition: '0.3s',
    backgroundColor: 'transparent',

    '&:not([disabled]):hover': {
      borderColor: '#004f9f'
    },
    '&:focus': {
      boxShadow: '0 0px 5px #004f9f',
      borderColor: '#004f9f'
    }
  }
})